import {APP_NAME, CACHE_PREFIX, ONE_DAY_TIME} from "./config"
import storage from "good-storage"
import {getENV, hashHasChannel, isEmpty, uuid} from "./util";
import {decryptByECB, encryptByECB} from "@/lib/cryptojs";
import dayjs from "dayjs";
import {DEFAULT_INDEX} from "@/router";

const formatStr = 'YYYY-MM-DD HH:mm:ss.SSS';
const query = url("?") || {}, hash = url("#") || {};
const env = getENV();
const channel = query.channel || hashHasChannel(hash) || env.appid;


export const getStartHash = {
  key: '_startHash',
  get(hash) {
    let info = storage.session.get(this.key);
    if (isEmpty(info)) {
      info = {value: this._get(hash), from: 'hash'}
      this.set(info);
    } else {
      info.from = 'cache';
    }
    return info;
  },
  _get(hash) {
    if (hash === '#/' || hash === '#' || !hash)
      hash = "#" + DEFAULT_INDEX;
    if (hash.startsWith('#/onlineDoctorCard'))
      hash = hash.replace('#/onlineDoctorCard', '#/doc/index');
    return hash;
  },
  set(value) {
    if (typeof value === 'object') {
      value.createTime = dayjs().format(formatStr);
    }
    storage.session.set(this.key, value);
  }
}


//aid 操作id
export const aidCAche = {
  key: '_aid',
  get() {
    let info = storage.session.get(this.key);
    if (isEmpty(info)) {
      info = {
        value: uuid(),
        from: 'create'
      }
      this.set(info);
    } else {
      info.from = 'cache';
    }
    return info;
  },
  set(value) {
    if (typeof value === 'object' && !value.createTime) {
      value.createTime = dayjs().format(formatStr);
    }
    storage.session.set(this.key, value);
  }
}


// token
const TOKEN_KEY = CACHE_PREFIX + channel + '_' + "token_";
export const tokenCache = {
  limit: 2,
  get() {
    let openid = storage.get(TOKEN_KEY, null);
    try {
      openid = decryptByECB(openid);
      openid = JSON.parse(openid);
    } catch (e) {
      openid = "";
    }
    if (!openid || typeof openid === 'string') {
      return null;
    }
    const {expires, value} = openid;
    // Log('openid expires, value', expires, value)
    if (typeof expires !== 'number' || Date.now() > expires) {
      return null;
    }
    return value;
  },
  set(value) {
    const tomorrow = dayjs().add(this.limit, 'day').startOf('day');// 0点过期
    Log('过期时间', tomorrow);
    let options = {
      value,
      expires: tomorrow.valueOf()
    };
    options = JSON.stringify(options);
    options = encryptByECB(options);
    storage.set(TOKEN_KEY, options);
  }
}

const OPEN_ID_KEY = CACHE_PREFIX + channel + '_' + "openid_";
export const openidCache = {
  get() {
    return storage.get(OPEN_ID_KEY, null);
  },
  set(value) {
    storage.set(OPEN_ID_KEY, value);
  }
}

const WX_USER_KEY = CACHE_PREFIX + "user_";
export const userCache = {
  get() {
    return storage.get(WX_USER_KEY, null);
  },
  set(value) {
    storage.set(WX_USER_KEY, value);
  }
}


const WX_DELPIC_KEY = CACHE_PREFIX + "delpic_";
export const delpicCache = {
  get() {
    return storage.session.get(WX_DELPIC_KEY, null);
  },
  set(value) {
    storage.session.set(WX_DELPIC_KEY, value);
  }
}

/**
 * 前一页记录
 * @type {string}
 */
const FROM_PAGE_KEY = CACHE_PREFIX + "from_page_key";
export const fromPageCache = {
  get() {
    return storage.session.get(FROM_PAGE_KEY, null);
  },
  set(value) {
    storage.session.set(FROM_PAGE_KEY, value);
  }
}

const WX_BACKPATH_KEY = CACHE_PREFIX + "backpath_";
export const backpathCache = {
  get() {
    return storage.session.get(WX_BACKPATH_KEY, null);
  },
  set(value) {
    storage.session.set(WX_BACKPATH_KEY, value);
  },
  remove() {
    storage.session.remove(WX_BACKPATH_KEY);
  }
}


const SEARCH_KEY = CACHE_PREFIX + "search_";
export const searchCache = {
  get() {
    return storage.session.get(SEARCH_KEY, null);
  },
  set(value) {
    storage.session.set(SEARCH_KEY, value);
  },
  remove() {
    storage.session.remove(SEARCH_KEY);
  }
}


const COUPONS_KEY = CACHE_PREFIX + "coupons_";
export const couponsCache = {
  get() {
    return storage.session.get(COUPONS_KEY, null);
  },
  set(value) {
    storage.session.set(COUPONS_KEY, value);
  },
  remove() {
    storage.session.remove(COUPONS_KEY);
  }
}


const ORDER_KEY = CACHE_PREFIX + "order_";
export const orderCache = {
  get() {
    return storage.session.get(ORDER_KEY, null);
  },
  set(value) {
    storage.session.set(ORDER_KEY, value);
  },
  remove() {
    storage.session.remove(ORDER_KEY);
  }
}

const CHART_KEY = CACHE_PREFIX + "chart_";
export const chartCache = {
  get() {
    return storage.session.get(CHART_KEY, null);
  },
  set(value) {
    storage.session.set(CHART_KEY, value);
  },
  remove() {
    storage.session.remove(CHART_KEY);
  }
}

const audio_play_status_KEY = CACHE_PREFIX + "audio_play_status_";
export const audioPlayStatusCache = {
  get() {
    return storage.session.get(audio_play_status_KEY, null);
  },
  set(value) {
    storage.session.set(audio_play_status_KEY, value);
  },
  remove() {
    storage.session.remove(audio_play_status_KEY);
  }
}
/**
 * 当前常用就诊人
 * @type {string}
 */
const compat_KEY = CACHE_PREFIX + "compat_";
export const compatCache = {
  get() {
    return storage.session.get(compat_KEY, null);
  },
  set(value) {
    storage.session.set(compat_KEY, value);
  },
  remove() {
    storage.session.remove(compat_KEY);
  }
}

/**
 * 当前常用就诊人索引
 * @type {string}
 */
const compat_index_KEY = CACHE_PREFIX + "compat_index_";
export const compatIndexCache = {
  get() {
    return storage.session.get(compat_index_KEY, null);
  },
  set(value) {
    storage.session.set(compat_index_KEY, value);
  },
  remove() {
    storage.session.remove(compat_index_KEY);
  }
}

const examination_KEY = CACHE_PREFIX + "examination_";
export const examinationCache = {
  get() {
    return storage.session.get(examination_KEY, null);
  },
  set(value) {
    storage.session.set(examination_KEY, value);
  },
  remove() {
    storage.session.remove(examination_KEY);
  }
}

const inspect_KEY = CACHE_PREFIX + "inspect_";
export const inspectCache = {
  get() {
    return storage.session.get(inspect_KEY, null);
  },
  set(value) {
    storage.session.set(inspect_KEY, value);
  },
  remove() {
    storage.session.remove(inspect_KEY);
  }
}

const test_KEY = CACHE_PREFIX + "test_";
export const testCache = {
  get() {
    return storage.session.get(test_KEY, null);
  },
  set(value) {
    storage.session.set(test_KEY, value);
  },
  remove() {
    storage.session.remove(test_KEY);
  }
}

const history_KEY = CACHE_PREFIX + "history_";
export const historyCache = {
  get() {
    return storage.session.get(history_KEY, null);
  },
  set(value) {
    storage.session.set(history_KEY, value);
  },
  remove() {
    storage.session.remove(history_KEY);
  }
}

const history_length_KEY = CACHE_PREFIX + "history_length_";
export const historyLengthCache = {
  get() {
    return storage.session.get(history_length_KEY, 0);
  },
  set(value) {
    storage.session.set(history_length_KEY, value);
  },
  plus() {
    const length = storage.session.get(history_length_KEY, 0) || 0;
    storage.session.set(history_length_KEY, length + 1);
  },
  remove() {
    storage.session.remove(history_length_KEY);
  }
}

const deep_KEY = CACHE_PREFIX + "deep_";
export const deepCache = {
  get() {
    return storage.session.get(deep_KEY, null);
  },
  set(value) {
    storage.session.set(deep_KEY, value);
  },
  remove() {
    storage.session.remove(deep_KEY);
  }
}

const callback_KEY = CACHE_PREFIX + "callback_";
export const callbackCache = {
  get() {
    return storage.get(callback_KEY, null);
  },
  set(value) {
    storage.set(callback_KEY, value);
  },
  remove() {
    storage.remove(callback_KEY);
  }
}

const introscope_KEY = CACHE_PREFIX + "introscope_";
export const introscopeCache = {
  get() {
    return storage.session.get(introscope_KEY, null);
  },
  set(value) {
    storage.session.set(introscope_KEY, value);
  },
  remove() {
    storage.session.remove(introscope_KEY);
  }
}

const MEDICAL_ORDER_KEY = CACHE_PREFIX + "medical_";
export const medicalOrderCache = {
  get() {
    return storage.session.get(MEDICAL_ORDER_KEY, null);
  },
  set(value) {
    storage.session.set(MEDICAL_ORDER_KEY, value);
  }
}

const ADDRESS_KEY = CACHE_PREFIX + "address_";
export const addressCache = {
  get() {
    return storage.session.get(ADDRESS_KEY, null);
  },
  set(value) {
    storage.session.set(ADDRESS_KEY, value);
  }
}

const NEXT_ACTION = CACHE_PREFIX + "next_";
export const nextActionCache = {
  get() {
    return storage.session.get(NEXT_ACTION, null);
  },
  set(value) {
    storage.session.set(NEXT_ACTION, value);
  }
}

/**
 * 肿瘤中心引导页是否打开
 * @type {string}
 */
const TUMOUR_WELCOME_HAS_OPENED = CACHE_PREFIX + 'tumour_welcome_opened';
export const tumourWelcomeOpenedCache = {
  get() {
    return storage.get(TUMOUR_WELCOME_HAS_OPENED, null);
  },
  set(value) {
    storage.set(TUMOUR_WELCOME_HAS_OPENED, value);
  }
};

/**
 * 肿瘤中心默认就诊人id
 * @type {string}
 */
const TUMOUR_DEFAUL_COMMPAT = CACHE_PREFIX + 'tumour_default_commpat';
export const tumourDefaultCommpatCache = {
  get() {
    return storage.get(TUMOUR_DEFAUL_COMMPAT, null);
  },
  set(value) {
    storage.set(TUMOUR_DEFAUL_COMMPAT, value);
  }
};

/**
 * 预约挂号搜索医生历史记录
 * @type {string}
 */
const BOOK_SEARCH_HISTORY = CACHE_PREFIX + 'book_search_history';
export const bookSearchHistoryCache = {
  get() {
    return storage.get(BOOK_SEARCH_HISTORY, null);
  },
  set(value) {
    storage.set(BOOK_SEARCH_HISTORY, value);
  }
};

/**
 * 团队体检订单详情
 * @type {string}
 */
const TEAM_TJ_INFO = CACHE_PREFIX + 'team_tj_info';
export const teamTjInfoCache = {
  get() {
    return storage.get(TEAM_TJ_INFO, null);
  },
  set(value) {
    storage.set(TEAM_TJ_INFO, value);
  }
};

/**
 * 是否阅读隐私协议
 * @type {string}
 */
const hasReadYsxy = CACHE_PREFIX + 'hasReadYsxy';
export const hasReadYsxyCache = {
  get() {
    return storage.get(hasReadYsxy, null);
  },
  set(value) {
    storage.set(hasReadYsxy, value);
  }
};

/**
 * 是否阅读用户协议
 * @type {string}
 */
const hasReadYhxy = CACHE_PREFIX + 'hasReadYhxy';
export const hasReadYhxyCache = {
  get() {
    return storage.session.get(hasReadYhxy, null);
  },
  /**
   *
   * @param value {renewal,pic,team}
   */
  set(value) {
    storage.session.set(hasReadYhxy, value);
  }
};

/**
 * 应用基本配置
 * @type {string}
 */
const appidConfigKey = CACHE_PREFIX + 'appidConfig';
export const appidConfigCache = {
  get() {
    return storage.session.get(appidConfigKey, null);
  },
  /**
   *
   * @param value {renewal,pic,team}
   */
  set(value) {
    storage.session.set(appidConfigKey, value);
  }
};

/**
 * 门诊支付待支付详情缓存
 * @type {string}
 */
export const mzzf_dzf_item_cache_key = 'mzzf_dzf_item_cache_key'

/**
 * 计算缓存
 */
export const calcCache = function () {
  let total = 0;
  const danwei = ['B', 'KB', 'MB', 'GB'];
  if (storage && storage.getAll) {
    const all = storage.getAll();
    for (let key in all) {
      total += calc(window.localStorage.getItem(key), key);
    }
  } else storage && storage.forEach && storage.forEach(key => {
    total += calc(window.localStorage.getItem(key), key);
  })

  function calc(str, key) {
    if (!str) return 0;
    let num = str.length;
    var arr = str.match(/[^x00-x80]/);
    if (arr != null) {
      num += arr.length * 2;
    }
    Log('cache key', key, num);
    return num;
  }

  function format(num, dwIndex) {
    if (num <= 1024) return parseFloat(num).toFixed(2) + danwei[dwIndex];
    else return format(num / 1024, dwIndex + 1);
  }

  return format(total, 0);
}

/**
 * 清理废弃缓存机制
 */
export const clearCache = function () {
  Log('getAll', APP_NAME, CACHE_PREFIX)
  let all = storage.getAll && storage.getAll()
  if (!isEmpty(all)) {
    for (let key in all) {
      removeKey(key)
    }
  } else {
    storage.forEach && storage.forEach(key => {
      removeKey(key)
    })
  }

  function removeKey(key) {
    if (!key.startsWith(APP_NAME)) {
      Log('remove key', key)
      storage.remove(key);
    }
    if (key.startsWith(APP_NAME) && !key.startsWith(CACHE_PREFIX)) {
      Log('remove key', key)
      storage.remove(key)
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/cache.js